<template>
  <div class="remember-device-container">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="rememberDevice"
        v-model="checked"
        @change="updateValue"
      />
      <label class="form-check-label" for="rememberDevice">
        {{ getrans("Remember this device for 30 days?") }}
      </label>
    </div>
    <div v-if="checked" class="security-notice">
       <small>{{ getrans("We’ll use a secure cookie to keep you signed in on this browser, so you don’t have to re-enter your code each time.") }}</small>

      <small>{{ getrans("This cookie lasts 30 days or until you clear your cookies. Don’t use this on shared devices – others could access your account.") }}</small>

      <small>{{ getrans("By choosing this, you agree to how we use cookies and handle your data under applicable data protection laws. [Privacy & Cookie Policy]") }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "RememberDeviceComponent",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: this.modelValue
    };
  },
  methods: {
    getrans(text) {
      // Using the parent component's translation method if available
      return this.$parent.getrans ? this.$parent.getrans(text) : text;
    },
    updateValue() {
      this.$emit('update:modelValue', this.checked);
    }
  },
  watch: {
    modelValue(newVal) {
      this.checked = newVal;
    }
  }
};
</script>

<style scoped>
.remember-device-container {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check-input {
  margin-right: .5rem;
}

.form-check-label {
  font-size: 1rem;
  cursor: pointer;
}

.security-notice {
  margin-top: .5rem;
  color: #666;
  font-size: .8rem;
}
</style>